// Operadores de data dos atributos personalizados no painel, espelho de FazerAi::CustomAttributes::DateOperators e
// DateValue (Onda 0): os quatro viram um intervalo fechado de dias "AAAA-MM-DD" no fuso da conta.
//   between   ["2026-10-01", "2026-10-31"]
//   in_month  ["2026-10"]
//   next_days [7]  hoje ate hoje + 7
//   last_days [7]  hoje - 7 ate hoje
export { todayIn as todayInTimeZone } from 'dashboard/composables/useAccountTimeZone';

export const DATE_RANGE_OPERATORS = [
  'between',
  'in_month',
  'next_days',
  'last_days',
];
export const RELATIVE_DAYS_MIN = 1;
export const RELATIVE_DAYS_MAX = 998;

const DAY = /^\d{4}-\d{2}-\d{2}$/;
const MONTH = /^\d{4}-\d{2}$/;
const WHOLE_NUMBER = /^\d+$/;

// Data do calendario (sem fuso) a partir de "AAAA-MM-DD"; null se o dia nao existe (ex.: 2026-02-30).
const parseDay = value => {
  if (!DAY.test(value)) return null;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCMonth() === month - 1 ? date : null;
};

const formatDay = date => date.toISOString().slice(0, 10);

const addDays = (day, count) => {
  const date = parseDay(day);
  date.setUTCDate(date.getUTCDate() + count);
  return formatDay(date);
};

const relativeDays = value => {
  const text = String(value);
  if (!WHOLE_NUMBER.test(text)) return null;
  const count = Number(text);
  return count >= RELATIVE_DAYS_MIN && count <= RELATIVE_DAYS_MAX
    ? count
    : null;
};

const monthRange = value => {
  if (!MONTH.test(value)) return null;
  const first = parseDay(`${value}-01`);
  if (!first) return null;
  const last = new Date(
    Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)
  );
  return { start: formatDay(first), end: formatDay(last) };
};

// { start, end } do operador, ou null quando os valores nao tem o formato documentado.
export const resolveDateRange = (operator, values, today) => {
  const list = Array.isArray(values) ? values : [values];
  if (operator === 'between') {
    const [start, end] = list;
    if (list.length !== 2 || !parseDay(start) || !parseDay(end)) return null;
    return start <= end ? { start, end } : null;
  }
  if (operator === 'in_month') {
    return list.length === 1 ? monthRange(list[0]) : null;
  }
  const count = list.length === 1 ? relativeDays(list[0]) : null;
  if (count === null) return null;
  if (operator === 'next_days') {
    return { start: today, end: addDays(today, count) };
  }
  if (operator === 'last_days') {
    return { start: addDays(today, -count), end: today };
  }
  return null;
};

export const isValidDateRangeValues = (operator, values) =>
  resolveDateRange(operator, values, '2000-01-01') !== null;

// Dia do atributo no fuso da conta: "AAAA-MM-DD" como esta; ISO com hora (o editor grava a meia-noite local em UTC)
// vira o dia nesse fuso; qualquer outro formato e null.
export const toCalendarDay = (value, timeZone) => {
  const text = String(value ?? '');
  if (DAY.test(text)) return parseDay(text) ? text : null;
  if (!/^\d{4}-\d{2}-\d{2}T/.test(text)) return null;
  const instant = new Date(text);
  if (Number.isNaN(instant.getTime())) return null;
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(instant);
};

export const isInDateRange = (day, range) =>
  Boolean(day && range && day >= range.start && day <= range.end);
